import { SeasonGroup, Species } from '@omniafishing/core';
import React from 'react';
import { SeasonGroupSelect } from '../../../../routes/map_page/season_group_select';
import { SpeciesSelectMobile } from '../../../../routes/map_page/species_select_mobile';

interface SpeciesSeasonFiltersProps {
  selectedSeasonGroup: SeasonGroup;
  selectedSpecies: Species;
  speciesOptions: Species[];
  onSpeciesSelect: (speciesName: string | null) => void;
  onSeasonGroupSelect: (seasonGroupName: string | null) => void;
}

export const SpeciesSeasonFilters = (props: SpeciesSeasonFiltersProps) => {
  const {
    selectedSeasonGroup,
    selectedSpecies,
    onSeasonGroupSelect,
    onSpeciesSelect,
    speciesOptions,
  } = props;

  return (
    <div className="flex gap-3 items-center justify-center">
      <SpeciesSelectMobile
        onSpeciesChange={onSpeciesSelect}
        selectedSpecies={selectedSpecies || null}
        speciesOptions={speciesOptions}
      />
      <SeasonGroupSelect value={selectedSeasonGroup?.name || null} onChange={onSeasonGroupSelect} />
    </div>
  );
};
